module.exports = __webpack_public_path__ + "static/img/uif.5cd42d22.png";